const adaptOption = (entity, { idKey, displayNameKey }) => {
  const { [idKey]: id, [displayNameKey]: displayName } = entity;

  return { id, displayName };
};

export const adaptOptionsFromEntity = (data, entityKey, config) => {
  return data?.[entityKey]?.map((entity) => adaptOption(entity, config)) || [];
};
